import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["value"]


export default /*#__PURE__*/_defineComponent({
  __name: 'TextareaField',
  props: /*#__PURE__*/_mergeModels({
    value: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const modelValue = _useModel(__props, "modelValue");

const onChange = (e: Event) => {
  modelValue.value = e.target?.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("textarea", {
    rows: "5",
    value: _ctx.value,
    onInput: onChange
  }, null, 40, _hoisted_1))
}
}

})